<div class="logout-dialog">
  <div class="logout-header">
    <span class="logout-icon" aria-hidden="true">
      <i class="pi pi-clock"></i>
    </span>
    <h4 class="logout-title">Tu sesión está por expirar</h4>
  </div>

  <div class="logout-body">
    <p class="logout-message">
      Por seguridad, tu sesión se cerrará automáticamente por inactividad.
    </p>

    <div
      class="logout-countdown"
      role="timer"
      aria-live="polite"
      [attr.aria-label]="'Quedan ' + secondsToLogout + ' segundos'"
    >
      <span class="logout-countdown__value">{{ secondsToLogout }}</span>
      <span class="logout-countdown__unit">segundos restantes</span>
    </div>

    <mat-progress-bar
      class="logout-progress"
      mode="determinate"
      [value]="progress"
      [class.logout-progress--urgent]="secondsToLogout <= 3"
    ></mat-progress-bar>
  </div>

  <div class="logout-actions">
    <button type="button" class="logout-btn logout-btn--ghost" (click)="executeLogout()">
      Cerrar sesión
    </button>
    <button type="button" class="logout-btn logout-btn--primary" (click)="activeModal.close(false)">
      Continuar conectado
    </button>
  </div>
</div>
